module.exports = __webpack_public_path__ + "static/media/honeyDip.6fb14f78.png";